import { PageHead } from "@/components/UI/atoms/PageHead/PageHead";
import { RepairOrdersTable } from "@/components/UI/organisms/RepairOrdersTable/RepairOrdersTable";
import * as React from "react";
import styles from "./Requests.module.scss";
import { useRepairOrders } from "@/hooks/RepairOrders";
import { IChartData } from "@/models/Charts/ChartData";
import _ from "lodash";
import { RosByMonth } from "@/components/UI/organisms/Charts/RosByMonth";
import { useWorkInProgress } from "@/hooks/WorkInProgress";
import { RosByService } from "@/components/UI/organisms/Charts/RosByService";
import { usePortalConfig } from "@/hooks/PortalConfig";
export interface IRequestsProps {}

export function Requests(props: IRequestsProps) {
	const { data: openRos, isLoading } = useRepairOrders("open");
	const { data: wips } = useWorkInProgress();
	const pc = usePortalConfig();
	const repairOrders = React.useMemo(() => {
		return openRos.filter((ro) => wips.find((wip) => wip.roId === ro.wipId));
	}, [wips, openRos]);

	return (
		<div className={styles.requests}>
			<PageHead pageTitle="Manage Requests" pageHead={"Manage Requests"}></PageHead>
			<div className={styles.chartRow}>
				<div className={styles.chart}>
					<RosByService
						title="Current Request by Type"
						loading={repairOrders.length === 0}
						repairOrders={repairOrders}></RosByService>
				</div>
				{!pc.data?.preview && (
					<div className={styles.chart}>
						<RosByMonth
							title="Request Status by Month"
							loading={repairOrders.length === 0}
							repairOrders={repairOrders}></RosByMonth>
					</div>
				)}
			</div>
			<RepairOrdersTable
				repairOrders={repairOrders}
				hideSubStatus
				emptyMessage="No active repair orders"
				loading={isLoading && !repairOrders.length}></RepairOrdersTable>
		</div>
	);
}
